<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>mupi 2c</title>
      <path fill="#679940"
        d="M17.5,5h-7a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V6A1,1,0,0,0,17.5,5Zm-1,17h-5V7h5Z"
      />
      <path fill="#679940"
        d="M25.5,5h-3V2a1,1,0,0,0-1-1H6.5a1,1,0,0,0-1,1V25s0,0,0,.07a1.29,1.29,0,0,0,0,.19,1.07,1.07,0,0,0,.07.19s0,0,0,.06l3,5A1,1,0,0,0,9.5,31h9a1,1,0,0,0,.86-.49l3-5s0,0,0-.06a1.07,1.07,0,0,0,.07-.19,1.29,1.29,0,0,0,0-.19s0-.05,0-.07V7h2V24.72l-2.86,4.77A1,1,0,0,0,22,30.86a1,1,0,0,0,.51.14,1,1,0,0,0,.86-.49l3-5A1,1,0,0,0,26.5,25V6A1,1,0,0,0,25.5,5ZM17.93,29H10.07L7.5,24.72V3h13V24.72Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Mupi2c"
};
</script>


// WEBPACK FOOTER //
// src/icons/Mupi2cIcon.vue